export default __webpack_public_path__ + "static/media/ballerized-full-logo.1501177b.png";